// src/index.tsx
import { Routes, Route } from 'react-router-dom';
import MainPage from '../pages/MainPage';
import { Booking } from '../components/Booking';
import { Card } from '../pages/Card';

const RoutesConfig = () => {
  const handleCartConfirm = () => {
    window.location.href = '/services';
  };

  const handleCartCancel = (id: number) => {
    console.log(`Бронирование ${id} удалено`);
  };

  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/services" element={<Booking />} />
      <Route 
        path="/Card" 
        element={
          <Card 
            onConfirm={handleCartConfirm}
            onCancel={handleCartCancel}
          />
        }
      />
    </Routes>
  );
};

export default RoutesConfig;